import { getConfig, launchECG } from '@/core/classes/MedconnectDevicesAPI'
import { DEVICES, MedconnectDevicesConfig } from '@/constants/medconnect-devices-types'
import { Chip, CircularProgress, Grid, Typography } from '@mui/material'
import SelectInput from '@/components/ui/inputs/SelectInput'
import { ExaminationTypes } from '@/core/classes/MedconnectDevicesAPI'
import colors from '@/assets/scss/_themes-vars.module.scss'
import { useAppSelector } from '@/redux/rootReducer'
import { selectConsultationById } from '@/redux/reducers/consultation.reducer'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { Box } from '@mui/system'
import { buildDevicePatient } from '@/utils/medconnectDevices/patientBiometrics'

const ExamTypes: ExaminationTypes[] = [ExaminationTypes.RestingECG, ExaminationTypes.Spirometry, ExaminationTypes.StressECG]

type SchillerECGProps = {
  consultationId?: string
}
export function SchillerECG({ consultationId }: SchillerECGProps) {
  const consultation = useAppSelector((state) => (consultationId ? selectConsultationById(state, consultationId) : undefined))

  const { t } = useTranslation()

  const [selectedExam, setSelectedExam] = useState<ExaminationTypes | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const handleSelectExam = (exam: ExaminationTypes) => {
    const patient = buildDevicePatient(consultation)
    const showLoaderAndReset = () => {
      setLoading(true)
      setTimeout(() => {
        setLoading(false)
        setSelectedExam(null)
      }, 1000)
    }

    if (!patient) return
    setSelectedExam(exam)
    launchECG({
      patient,
      type: exam ? exam : ExaminationTypes.RestingECG,
    })
    showLoaderAndReset()
  }
  const [config, setConfig] = useState<MedconnectDevicesConfig | undefined>(undefined)
  useEffect(() => {
    const handleConfig = async () => {
      const config = await getConfig()
      if (!config) return
      setConfig(config)
    }
    handleConfig()
  }, [])

  if (!config?.Devices) return null

  if (config?.Devices.filter((device) => device.name === DEVICES.SCHILLER_ECG).length === 0) {
    return null
  }

  return (
    <Grid item xs={12} sm={6}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Typography variant="h6" component="div" sx={{ color: colors.gray900, fontSize: '16px', fontWeight: 500, lineHeight: '24px' }}>
          {t(`component.ui.deviceCard.deviceLabels.${DEVICES.SCHILLER_ECG}`)}
        </Typography>
        <Chip color="success" label={t(`component.ui.deviceCard.installed.label`)} variant="filled" size="small" />
      </Box>
      <Box sx={{ position: 'relative', maxWidth: 200 }}>
        <SelectInput
          value={selectedExam ? selectedExam : null}
          label={t('component.ui.MedconnectDevice.examSelector.examType')}
          options={ExamTypes.map((e) => {
            return {
              label: t(`component.ui.MedconnectDevice.examSelector.type.${e}`),
              value: e,
            }
          })}
          placeholder="Select exam type"
          required
          sx={{ width: '100%' }}
          onChange={(e) => handleSelectExam(e.target.value as ExaminationTypes)}
          disabled={loading}
        />
        {loading && (
          <CircularProgress
            size={24}
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              marginTop: '-12px',
              marginLeft: '-12px',
            }}
          />
        )}
      </Box>
    </Grid>
  )
}
